import { Media } from "./media";

export interface User {
    id: number;
    name: string;
    email: string;
    first_name: string;
    last_name: string;
    birthdate: string;
    phone: string;
    document_id: string;
    description: string;
    slug: string;
    role: any[];
    // meta: any[];
    avatar: Media[];
    club: number[];
    teams: number[];
    status: number;
}

export const emptyUser: User = {
    id: 0,
    name: '',
    email: '',
    first_name: '',
    last_name: '',
    birthdate: '',
    phone: '',
    document_id: '',
    description: '',
    slug: '',
    role: [],
    // meta: any[];
    avatar: [],
    club: [],
    teams: [],
    status: 0
}